import { useState } from "react";

// Purely visual UI states that span multiple slices of the report and would
// otherwise need to prop-drill. Any future cross-slice UI toggle can find its' home here
export const useReportUIStateController = () => {
  const [hideProjectedDebtSection, setHideProjectedDebtSection] =
    useState(false);

  return {
    hideProjectedDebtSection,
    setHideProjectedDebtSection
  };
};
